import { connect } from 'react-redux';
import { dailyBlotterFiltersUpdated } from 'state/blotters/dailyBlotter/dailyBlotter.action';
import type { Filters } from 'state/blotters/dailyBlotter/dailyBlotter.model';
import { getDailyBlotterQuotesInfo } from 'state/blotters/dailyBlotter/dailyBlotter.selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export interface StateProps {
  filters: Filters;
}

export interface ToolBarDispatchProps {
  updateFilters(filters: Filters): void;
}

export type ToolBarState = StateProps & ToolBarDispatchProps;
export const mapStateToProps = (state: AppState): StateProps => {
  return {
    filters: getDailyBlotterQuotesInfo(state).filters,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): ToolBarDispatchProps => ({
  updateFilters(filters: Filters) {
    dispatch(dailyBlotterFiltersUpdated(filters));
  },
});

export const connectDailyBlotterToolBar = connect(mapStateToProps, mapDispatchToProps);
